
import { IGroupMemberStats } from '@grassrootly/api/entities';
import { provider } from "@grassrootly/api/providers";
import { GetMembersWithStatsParams } from './GetGroupMembersWithAvgRatings';

export const GetGroupMembersWithAssists = async (params: GetMembersWithStatsParams):
  Promise<IGroupMemberStats[]> =>
  provider.Request("/get_top_assists_by_group", params);
